import "./tabs.css";

import React from "react";

//Row of tabs with one panel showing (Home rooms, Gallery). Arrow keys / Home / End move between tabs.
//renderPanel(index) draws the chosen tab's content
const Tabs = ({ id, labels, renderPanel, className = "" }) => {
  const [current, setCurrent] = React.useState(0);
  const listRef = React.useRef(null);

  const select = (i, focus = false) => {
    setCurrent(i);
    const tab = listRef.current.children[i];
    if (focus) {
      tab.focus();
    }
    //Keep the chosen tab in view when the row scrolls sideways (phones)
    tab.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
  };

  const onKeyDown = (e) => {
    const last = labels.length - 1;
    const keys = {
      ArrowRight: current === last ? 0 : current + 1,
      ArrowLeft: current === 0 ? last : current - 1,
      Home: 0,
      End: last,
    };
    if (e.key in keys) {
      e.preventDefault();
      select(keys[e.key], true);
    }
  };

  return (
    <div className={`tabs ${className}`}>
      <div
        ref={listRef}
        className={"tabs-list"}
        role={"tablist"}
        onKeyDown={onKeyDown}
      >
        {labels.map((label, i) => (
          <button
            key={label}
            id={`${id}-tab-${i}`}
            type={"button"}
            role={"tab"}
            className={`tabs-tab ${i === current ? "is-current" : ""}`}
            aria-selected={i === current}
            aria-controls={`${id}-panel`}
            tabIndex={i === current ? 0 : -1}
            onClick={() => select(i)}
          >
            {label}
          </button>
        ))}
      </div>
      <div
        id={`${id}-panel`}
        className={"tabs-panel"}
        role={"tabpanel"}
        aria-labelledby={`${id}-tab-${current}`}
      >
        <React.Fragment key={current}>
          {renderPanel(current)}
        </React.Fragment>
      </div>
    </div>
  );
};

export default Tabs;
